import SharedViewVendorModal from "@/components/shared/ViewVendorModal";
import type { ComponentProps } from "react";

type SharedProps = Omit<ComponentProps<typeof SharedViewVendorModal>, "showAssociatedUsers">;

export default function ViewVendorModal(props: SharedProps) {
  return <SharedViewVendorModal {...props} showAssociatedUsers={false} />;
}
